import { gql } from "@apollo/client";

import { CAMPAIGN_FIELDS_FOR_TEXTER } from "./campaigns";

export const LIST_MY_INBOXES = gql`
  query listMyInboxes($input: ListMyInboxesInput!) {
    listMyInboxes(input: $input) {
      __typename
      id
      subaccount {
        slug
      }
      inboxType
      joinedAt

      stats {
        numAssignments
        numRepliesAssigned
        numRepliesAvailable
      }

      ... on CampaignInboxSummary {
        campaign {
          id
          name
          status
          description
          startedAt
          texterSendEnabled
          texterSendBatchSize
          withinTextingHours
          sendProgress
          myCampaignSends {
            id
            status
            batchSize
          }
        }
      }

      ... on GeneralInboxSummary {
        inboxName
        availableTexterSend
      }

      ... on EscalationInboxSummary {
        inboxName
      }
    }
  }
`;

export const GET_INBOX = gql`
  ${CAMPAIGN_FIELDS_FOR_TEXTER}
  query getInbox($input: GetInboxInput!) {
    getInbox(input: $input) {
      __typename
      id
      inboxName
      subaccount {
        slug
      }
      stats {
        numAssignments
        numRepliesAssigned
        numRepliesAvailable
      }
      inboxType
      joinedAt

      ... on CampaignInboxSummary {
        campaign {
          ...CampaignFieldsForTexter
          myCampaignSends {
            id
            status
            batchSize
          }
        }
      }

      ... on GeneralInboxDetails {
        inboxName
        availableTexterSend
        statsByCampaign {
          campaign {
            id
            name
            description
            startedAt
            status
            sendProgress
            texterSendEnabled
            texterSendBatchSize
            withinTextingHours
            myCampaignSends {
              id
              status
              batchSize
            }
          }
          availableCount
          assignmentCount
          assignmentNeedsReplyCount
        }
      }

      ... on EscalationInboxDetails {
        inboxName
        statsByCampaign {
          campaign {
            id
            name
            description
            startedAt
            status
            sendProgress
            texterSendEnabled
            texterSendBatchSize
            withinTextingHours
            myCampaignSends {
              id
              status
              batchSize
            }
          }
          availableCount
          assignmentCount
          assignmentNeedsReplyCount
        }
      }
    }
  }
`;

export const JOIN_INBOX = gql`
  mutation joinInbox($input: JoinInboxInput!) {
    joinInbox(input: $input) {
      success
    }
  }
`;

export const ROTATE_INBOX_JOIN_TOKEN = gql`
  mutation rotateInboxJoinToken($input: RotateInboxJoinTokenInput!) {
    rotateInboxJoinToken(input: $input) {
      id
      joinToken
    }
  }
`;

export const LIST_INBOX_USERS = gql`
  query listCampaignInboxUsers($input: ListCampaignInboxUsersInput!) {
    listCampaignInboxUsers(input: $input) {
      totalCount
      userInboxes {
        id
        userInbox {
          id
          user {
            fullName
            email
          }
        }
        numRepliesSent
      }
    }
  }
`;

export const REMOVE_USER_FROM_INBOX = gql`
  mutation removeUserFromInbox($input: RemoveUserFromInboxInput!) {
    removeUserFromInbox(input: $input) {
      success
    }
  }
`;

export const LIST_SUBACCOUNT_ESCALATION_INBOXES = gql`
  query listSubaccountEscalationInboxes(
    $input: ListSubaccountEscalationInboxesInput!
  ) {
    listSubaccountEscalationInboxes(input: $input) {
      id
      name
      texterAssignmentBatchSize
      texterAssignmentExpirationMinutes
      userInboxes {
        id
        user {
          id
          fullName
        }
      }
      threadCount
      needsReplyCount
    }
  }
`;

export const LIST_SUBACCOUNT_ESCALATION_INBOXES_FOR_TEXTER = gql`
  query listSubaccountEscalationInboxesForTexter(
    $input: ListSubaccountEscalationInboxesInput!
  ) {
    listSubaccountEscalationInboxes(input: $input) {
      id
      name
    }
  }
`;

export const CREATE_INBOX = gql`
  mutation createInbox($input: CreateInboxInput!) {
    createInbox(input: $input) {
      id
    }
  }
`;

export const EDIT_INBOX = gql`
  mutation editInbox($input: EditInboxInput!) {
    editInbox(input: $input) {
      id
    }
  }
`;

export const DELETE_ESCALATION_INBOX = gql`
  mutation deleteEscalationInbox($input: DeleteEscalationInboxInput!) {
    deleteEscalationInbox(input: $input) {
      ok
    }
  }
`;

export const LIST_SUBACCOUNT_GENERAL_INBOXES = gql`
  query listSubaccountGeneralInboxes(
    $input: ListSubaccountGeneralInboxesInput!
  ) {
    listSubaccountGeneralInboxes(input: $input) {
      id
      name
      texterAssignmentBatchSize
      texterAssignmentExpirationMinutes
      threadCount
      needsReplyCount
      userInboxes {
        id
        user {
          id
          fullName
        }
      }
    }
  }
`;

export const LIST_SUBACCOUNT_ESCALATION_AND_GENERAL_INBOXES = gql`
  query listSubaccountEscalationAndGeneralInboxes($subaccountId: String!) {
    listSubaccountGeneralInboxes(input: { subaccountId: $subaccountId }) {
      id
      name
      texterAssignmentBatchSize
      texterAssignmentExpirationMinutes
      threadCount
      needsReplyCount
      userInboxes {
        id
        user {
          id
          fullName
        }
      }
    }

    listSubaccountEscalationInboxes(input: { subaccountId: $subaccountId }) {
      id
      name
      texterAssignmentBatchSize
      texterAssignmentExpirationMinutes
      userInboxes {
        id
        user {
          id
          fullName
        }
      }
      threadCount
      needsReplyCount
    }
  }
`;
